<template>
  <div>
    <nav
      class="navbar navbar-expand-lg navbar-light bg-light fixed-top p-st"
      :class="{
        'bg-light': !nightMode,
        'navbar-blur': navbarConfig.blur,
        'bg-dark2': nightMode,
      }"
    >
      <div class="container">
        <a
          class="navbar-brand"
          href="/"
          @click.prevent="$emit('scroll', 'home')"
        >
          <Logo :nightMode="nightMode" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span style="color: gray; font-size: 23px;"
            ><i class="fas fa-bars"></i>
            </span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item mx-2"  :class="{'nav-item-active': isActive =='skills'}">
              <a
                class="nav-link"
                href="/skills"
                @click.prevent="clickItem('skills')"
                :class="{'nav-item-active': isActive =='skills', 'text-light': nightMode}"
                >Skills</a
              >
            </li>
            <li class="nav-item mx-2 " :class="{'nav-item-active': isActive =='portfolio'}">
              <a
                class="nav-link"
                href="/portfolio"
                @click.prevent="clickItem('portfolio')"
                :class="{'nav-item-active': isActive =='portfolio', 'text-light': nightMode}"
                >Portfolio</a
              >
            </li>
            <li class="nav-item mx-2 " :class="{'nav-item-active': isActive =='about'}">
              <a
                class="nav-link"
                href="/clients"
                @click.prevent="clickItem('clients')"
                :class="{'text-light': nightMode}"
                >Clients</a
              >
            </li>
            <li class="nav-item mx-2" :class="{'nav-item-active': isActive =='contact'}">
              <a
                class="nav-link"
                href="/contact"
                @click.prevent="clickItem('contact')"
                :class="{'text-light': nightMode}"
                >Contact</a
              >
            </li>
            <li class="nav-item ml-2">
              <a
                class="nav-link"
                href="#"
                @click.prevent="switchMode"
                :class="{ 'text-light': nightMode }"
                ><i
                  :class="{
                    'fas fa-moon': nightMode,
                    'far fa-moon': !nightMode,
                  }"
                  v-tooltip.bottom="nightMode ? 'Light Mode' : 'Night Mode'"
                ></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Logo from "./helpers/Logo";
import info from "../../info";

export default {
  name: "Navbar",
  props: {
    nightMode: {
      type: Boolean,
    },
    active: {
      type: String
    }
  },
  data() {
    return {
      navbarConfig: info.config.navbar,
      localNightMode: this.nightMode,
      isActive: 'Home'
    };
  },
  components: {
    Logo,
  },
  methods: {
    switchMode() {
      this.localNightMode = !this.localNightMode;
      this.$emit("nightMode", this.localNightMode);
    },
    clickItem(section){
      this.isActive = section;
      this.$emit('scroll', section);
      console.log(this.isActive, section)
    }
  },
};
</script>

<style scoped>
.nav-link {
  font-weight: 500;
}
.nav-link:hover{
  background-color: rgba(160, 159, 159, 0.336);
}

button {
  border: none;
  outline: none;
}

button:hover {
  border: none;
  outline: none;
}

nav {
  border-bottom: 1px solid rgba(160, 159, 159, 0.336);
  position: fixed !important;
}

.navbar-blur {
  background-color: #ffffff7e;
  backdrop-filter: blur(12px);
}
.nav-item-active a {
  color: #51c2af !important;
}
</style>
